import Modal, { closeModal } from "components/modal"

import SizeChart from "./size-chart"

const SizeGuideHalfModal = () => {
  return (
    <Modal
      label="Ring Sizing Chart"
      onClose={closeModal}
      show="#size-chart"
      variant="squircle"
      width="855px"
    >
      <SizeChart />
    </Modal>
  )
}

export default SizeGuideHalfModal
